import React, { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation';
import '../singleUseCard/singleUseCard.css';

const SingleUseCardWarning = (props: any): ReactElement => {
  return (
    <>
      <div className="single-use-card-error-section">
        <div className="single-use-error-block">
          <div className="exclamation-circle-section">
            <FontAwesomeIcon
              icon={faCircleExclamation}
              className="exclamation-circle-icon"
            />
          </div>
          <div className="single-use-card-error-text">
            {props.singleUseCardWarningMessage}
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleUseCardWarning;
